enum DashboardMetricType {
  DynamicWorkersInitialLeaseTime,
  InstanceFileUsage,
  InstanceExecutionsFileUsage,
  InstanceDatabaseSizeUsage,
  InstanceCpuUsage,
  InstanceMemoryUsage,
  InstanceUptime,
  AzureResourceManagerThrottleData,
  RelativeInstanceDatabaseCpuUsage,
  RelativeInstanceDatabaseDataIoUsage,
  RelativeInstanceDatabaseLogIoUsage,
  RelativeInstanceCpuUsage,
  RelativeInstancePodMemoryUsage,
  TaskLimitSaturation,
  TaskLimitLowerTierSaturation,
  PodRestarts,
  ProblematicInstanceTaskLocks,
}

export default DashboardMetricType;
